import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ProductSheetOptions, SelectedValues } from './product-sheet.model';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EventModel } from '@boxx/events-core/lib/models/events.model';

@Component({
  selector: 'app-product-sheet',
  templateUrl: './product-sheet.component.html',
  styleUrls: ['./product-sheet.component.scss']
})
export class ProductSheetComponent implements OnInit {

  @Input() config: ProductSheetOptions;
  selectedValue: string | SelectedValues;

  form: FormGroup = new FormGroup({
    quantity: new FormControl(6, [Validators.required, Validators.min(0)])
  });

  labelMinMax: string;
  websiteUrlString: string;
  translations: any;
  destroyed$ = new Subject<boolean>();
  isCordovaOrCapacitor = false;
  event: EventModel;



  public maxDate = (Number(new Date().getFullYear()) + 1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = '';
  public paramPres: string;
  public currentDate: string;

  customProductList: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.translate
      .get(['QR', 'CLIPBOARD', 'PANEL_VIEW', 'EVENTS_MODULE', 'ACTIONS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  async ngOnInit() {
    this.customProductList = this.config.data.map(item => {
      const previousItem = this.config.previousData.find(prev => prev.id === item.id);
    
      return {
        ...item,
        totalSelected: previousItem ? previousItem.totalSelected : 0,
        total: previousItem ? previousItem.total : item.price,
        productImage: (item.media?.images?.length > 0) ? item.media.images[0].image160pxUrl : ''
      };
    });
    
  }

  ionViewDidEnter() {
    if (this.config?.currentValue) {
    }
  }

  addProduct(id: number){
    for(let i = 0; i < this.customProductList.length; i++){
      if(Number(this.customProductList[i].id) === Number(id)){
        this.customProductList[i].totalSelected++; 
        this.customProductList[i].total = Number(this.customProductList[i].totalSelected) * Number(this.customProductList[i].price);
        return;
      }
    }
  }

  decreaseProduct(id: number){
    for(let i = 0; i < this.customProductList.length; i++){
      if(Number(this.customProductList[i].id) === Number(id)){
        this.customProductList[i].totalSelected--;
        if(this.customProductList[i].totalSelected > 0){
          this.customProductList[i].total = Number(this.customProductList[i].totalSelected) * Number(this.customProductList[i].price);
        }
        return;
      }
    }
  }

  onSelect() {
    this.modalCtrl.dismiss({ value: this.selectedValue });
  }

  accept(){
    let _productsSelected = this.customProductList.filter( (p) => p.totalSelected > 0 );
    this.modalCtrl.dismiss({ value: _productsSelected });
  }

  onCancelAction() {
    this.selectedValue = null;
    this.modalCtrl.dismiss({ value: { isCancel: true } });
  }

  closeActionSheet() {
    this.modalCtrl.dismiss();
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
